import { MessageDialog } from './MessageDialog';

export default MessageDialog;
